export default {};



// WEBPACK FOOTER //
// ./src/store/modules/dailypass/actions.js